// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ForgotPasswordForm_componentStyle__X1zZg"};